import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import initialState from './contactOrganizationAddressSliceInitialState';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getContactOrganizationAddress = createAsyncThunk(
  'stop/getContactOrganizationAddress',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const contactOrganizationAddressSlice = createSlice({
  name: 'stop/contactOrganizationAddress',
  initialState,
  reducers: {
    resetContactOrganizationAddress: (state) => initialState,
  },
  extraReducers: {
    [getContactOrganizationAddress.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetContactOrganizationAddress } =
  contactOrganizationAddressSlice.actions;
export default contactOrganizationAddressSlice.reducer;
